import { NoticeLoading } from '@fs/zion-icon'
import { Grid, Radio, RadioGroup, TextField } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function PersonOwnerPicker({
  name,
  disabled,
  textLabel,
  radioLabel,
  owner,
  updateIdType,
  updateId,
  loading,
  showSpinner,
  ...props
}) {
  const { t } = useTranslation()

  const isValid = () => {
    return owner?.ownerCisId || owner?.ownerTreeId
  }

  const getValidMessage = () => {
    if (isValid()) {
      if (owner?.ownerName === '') {
        if (owner?.input === 'ADMIN') return t('adminOwned', 'Admin Owned')
        if (owner?.input === 'PUBLIC') return t('public', 'Public')
      }
      let result
      if (owner?.ownerName != null) {
        result = owner.ownerName
      }
      if (result && owner?.ownerTreeType) {
        result += ` - ${t(`tree.type.${owner?.ownerTreeType}`, owner?.ownerTreeType)}`
      }
      return result || ''
    }
    return ''
  }

  const getHelperMessage = () => {
    if (loading) {
      return showSpinner && <NoticeLoading data-testid="show-spinner" />
    }
    if (owner?.input === 'ADMIN') return ''
    if (owner?.ownerName === '' && owner?.input !== '' && owner?.input !== undefined) {
      return owner.idType === 'cisId'
        ? t('prompt.enterValidOwnerCisId', 'Please enter valid Owner CIS ID')
        : t('prompt.enterValidOwnerTreeId', 'Please enter valid Owner Tree ID')
    }
    return owner.idType === 'cisId'
      ? t('prompt.enterOwnerCisId', 'Please enter Owner CIS ID')
      : t('prompt.enterOwnerTreeId', 'Please enter Owner Tree ID')
  }

  return (
    <Grid columns={12}>
      <RadioGroup columns={6} orientation="horizontal" label={radioLabel} disabled={disabled}>
        <Radio
          id="cisIdRadioBtn"
          checked={owner?.idType === 'cisId'}
          label={t('cisId', 'CIS ID')}
          name={`${name}-cisId`}
          value="cisId"
          onChange={updateIdType}
        />
        <Radio
          id="treeIdRadioBtn"
          checked={owner?.idType === 'treeId'}
          label={t('treeId', 'Tree ID')}
          name={`${name}-treeId`}
          value="treeId"
          onChange={updateIdType}
        />
      </RadioGroup>
      <TextField
        columns={6}
        {...props}
        role="textbox"
        id="ownerCisId"
        disabled={disabled}
        label={textLabel}
        value={owner?.input || ''}
        onChange={updateId}
        validMessage={getValidMessage()}
        helpMessage={props.disabled ? null : getHelperMessage()}
      />
    </Grid>
  )
}
